import { render, staticRenderFns } from "./BuilderSideBar.vue?vue&type=template&id=63a467e8&scoped=true&"
import script from "./BuilderSideBar.vue?vue&type=script&lang=js&"
export * from "./BuilderSideBar.vue?vue&type=script&lang=js&"
import style0 from "./BuilderSideBar.vue?vue&type=style&index=0&id=63a467e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a467e8",
  null
  
)

export default component.exports